import Vue from 'vue'
import formatName from 'filters/format-name'
import globalConfig from 'init/global.config'
import globalStore from 'init/global-store'
import msg from 'services/msg'
import Menu from 'objects/menu/menu'
import MenuList from 'objects/menu/menu-list'
import tokenService from 'services/token-service'

import withRender from './user-toolbar-m1.html'
import './user-toolbar.scss'


export default withRender(Vue.extend({
  components: {
    'tt-menu-list': MenuList,
    'tt-menu': Menu
  },
  data () {
    return {
      globalStore
    }
  },
  computed: {
    isLoggedIn() {
      return this.globalStore.user.id
    },
    formattedUsername() {
      return formatName(this.globalStore.user)
    },
    menuItems() {
      return [
        { name: 'logout', iconName: 'close',
          title: msg('userToolbar.menu.logout', [this.formattedUsername]) }
      ]
    },
    showToolbar() {
      return !globalConfig.ssoEnabled
    }
  },
  methods: {
    menuItemSelected (item) {
      if (item.name === 'logout') {
        tokenService.logoutUser()
      }
    }
  }
}))
